import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../../api";

export function usePlanWeekDeadlines(planId) {
  const [loading, setLoading] = useState(false);
  const [weeks, setWeeks] = useState([]);
  const [subjectSchedule, setSubjectSchedule] = useState([]);
  const [holidayDrafts, setHolidayDrafts] = useState({});

  const load = useCallback(async () => {
    if (!planId) {
      setWeeks([]);
      setSubjectSchedule([]);
      setHolidayDrafts({});
      return;
    }
    setLoading(true);
    try {
      const r = await api.get(`admin/course-plans/${planId}/weeks-with-deadlines`);
      const list = r.data?.weeks ?? [];
      setWeeks(list);
      setSubjectSchedule(r.data?.subject_schedule ?? []);
      const drafts = {};
      list.forEach((w) => {
        drafts[w.id] = { is_holiday: w.is_holiday, holiday_name: w.holiday_name || "" };
      });
      setHolidayDrafts(drafts);
    } catch {
      toast.error("Failed to load plan weeks");
      setWeeks([]);
      setSubjectSchedule([]);
    } finally {
      setLoading(false);
    }
  }, [planId]);

  useEffect(() => {
    load();
  }, [load]);

  return {
    loading,
    weeks,
    setWeeks,
    subjectSchedule,
    holidayDrafts,
    setHolidayDrafts,
    reload: load,
  };
}
